import React from 'react'
import { FormControl, Input, DateChooser, TimeChooser, Textarea, Switch, Select, Badge } from '@/components/lib'

export default function FormField ({ fieldProps, label, type, value, isChecked, options, onChange, helper, required, placeholder }) {
  function getInput () {
    if (type === 'textarea') return (<Textarea value={value} onChange={onChange} placeholder={placeholder} />)
    if (type === 'switch') return (<Switch isChecked={isChecked} onChange={onChange} />)
    if (type === 'select') {
      return (
        <Select value={value} onChange={onChange} placeholder={placeholder}>
          {options.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
        </Select>
      )
    }
    if (type === 'date') {
      return (
        <DateChooser value={value} onChange={onChange} />
      )
    }
    if (type === 'time') {
      return (
        <TimeChooser value={value} onChange={onChange} />
      )
    }
    return (<Input type={type} value={value} onChange={onChange} placeholder={placeholder} />)
  }

  return (
    <FormControl
      {...fieldProps}
      label={<span>{label} {required && <Badge colorPalette='yellow' ml={3}>Required</Badge>}</span>}
      helperText={helper}
    >
      {getInput()}
    </FormControl>
  )
}
